import axios from 'axios';

import Invitation from 'types/models/invitation';
import { APIResponseParsed } from 'types/response';
import { getRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

type FetchInvitationsParams = {
  enterpriseId?: number;
};

async function fetchInvitations(params: FetchInvitationsParams): Promise<APIResponseParsed<Invitation[]>> {
  try {
    const response = await getRequest<Invitation[]>('invitation', { params });
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export default {
  fetchInvitations
};